<template>
  <b-container>
    <h1 class="text-center pt-4 pb-4">{{ $t("title.inclusions") }}</h1>
      <b-row class="mt-2">
        <b-col sm="4" class="mt-4">
          <b-form-select v-model="building" :options="buildings" v-on:change="OnBuildingClick"></b-form-select>
        </b-col>
      </b-row>

      <div  v-if="building">
      
      <h5 class="mt-4">Inclusions</h5>
      <hr/>
      <b-row class="mt-2">
        <b-col class="mt-4">
          <b-form-checkbox-group
          v-model="inclusions"
          :options="optionsInc"
          class="mb-3"
          value-field="item"
          text-field="name"
          disabled-field="notEnabled"
        ></b-form-checkbox-group>
      </b-col>
    </b-row>
    

    <h5 class="mt-4">{{ $t("label.fiche.otherServices") }}</h5>
    <hr/>
     <b-form-checkbox-group
          v-model="otherServices"
          :options="optionsOS"
          class="mb-3"
          value-field="item"
          text-field="name"
          disabled-field="notEnabled"
          stacked
        ></b-form-checkbox-group>

  <b-row class="mt-2">
    <b-col sm=6>
        <div class="mt-2" v-for="(item, index) in inputOS" v-bind:key="item.Id">
          <b-form-input maxlength="150" v-if="otherServices.includes(item.Id)" :placeholder="optionsOS[index].name" v-model="item.value"></b-form-input>
        </div>
      </b-col>
    </b-row>

  <h5 class="mt-4">Promotions</h5>
  <hr/>
  <b-row class="mt-2">
    <b-col sm=6>
        <div class="mt-2" v-for="(item) in promotions" v-bind:key="item.Id">
          <b-form-input maxlength="150" v-model="item.value"></b-form-input>
        </div>
      </b-col>
    </b-row>

    <b-button class="mt-4 text-center" variant="success" :disabled="disabled" @click="ajaxCall()">{{ $t("action.submit") }}</b-button>
    

    <div v-if="spinner" class="text-center">
      <b-spinner style="width: 3rem; height: 3rem;" variant="success" label="Spinning" disabled="labelStatus"></b-spinner>
    </div>

    <div v-if="success" class="pt-4">
      <b-alert show variant="success">
        <p>{{ $t("info.successgeneric") }}</p>
      </b-alert>
    </div>

    <div v-if="error" class="pt-4">
    <b-alert show variant="danger">
        <p>{{ error }}</p>
    </b-alert>
    </div>

    
  </div>
</b-container>
</template>

<script>
  import axios from 'axios';
  import { mappBuildingDataForSelect } from '../../assets/Utils.js'; 
  import { globalF } from '../Helpers';

  export default {
  props: [],
  mixins: [globalF],
    data() {
      return {
        error: "",
        inclusions: [],
        optionsInc: [],
        otherServices: [],
        optionsOS: [],
        inputOS: [],
        inputOSValue: [],
        promotions: [{Id:1, value: ""}, {Id:2, value: ""}, {Id:3, value: ""}, {Id:4, value: ""}, {Id:5, value: ""}],
        building: this.getbuilding(),
        buildings: this.getBuildingsList(),
        spinner: false,
        success: false,
        disabled: false
      }
    },
    computed: { 
      currentLg: function () {
        return this.$i18n.locale;
      },     
    },
    watch: {
      currentLg: function () {
        if (this.building) {
          this.OnBuildingClick();
        }
      }
    },
    methods:{
    getBuildingsList: function () {
      let buildings = this.$store.getters.getUserBuilding;
        let res = [];
        if (buildings) {
          res = mappBuildingDataForSelect(buildings);
        }
        res.unshift({value: null, text: this.$t('label.properties')});
        return res;
    }, 
    mapLabelToList: function (list, type) {

      let lg = this.$i18n.locale;
      if (type === "inclusions") {
            this.optionsInc = list.map(m => {
              return { item: m.Id, name: lg === 'fr' ? m.fr : m.en };
          });
      }
      if (type === "otherServices") {
          this.optionsOS = list.map(m => {
              return { item: m.Id, name: lg === 'fr' ? m.fr : m.en };
          });

          this.inputOS = list.map(m => {
              return { Id: m.Id, value: "" };
          });
      }
    },
    getbuilding: function () {                   
        return null;
    },
    ajaxCall() {
      this.error = "";
      this.spinner = true;
      this.disabled = true;
      this.success = false;
      let urls = this.$store.getters.getUrlsList;
      let url = urls[process.env.VUE_APP_WHERE].json;
      let b = this.building;

      let obj = {
        NOCIE : b.NOCIE,
        NODIV: b.NODIV,
        Inclusions: JSON.stringify(this.inclusions),
        OtherServices: JSON.stringify({CheckboxGroup: this.otherServices, InputOS : this.inputOS}),
        Promotions: JSON.stringify(this.promotions)
      }

      let promise = this.validateToken();  
        promise.then(() => {

          axios.post(url, {request: "addBuildingInclusions", form: obj}, { headers: {'Content-Type': 'application/json'}})
          .then((res)  => {
                  let value = res.data;
                  this.spinner = false;
                  this.disabled = false;
                  this.success = true;
                  this.$store.commit('addUserBuilding', value.buildings);
                  this.buildings = this.getBuildingsList();
                  this.building = null;
            })
            .catch(()  => {
                  this.spinner = false;
                  this.disabled = false;
                  this.error = this.$t('info.errorgeneric');
            });
          
        });
  }, 
  OnBuildingClick: function () {  
    this.resetField();

    let b = this.building;
    let inclusionsLabel = this.getGlobalData("inclusions");
    let otherServicesLabel = this.getGlobalData("otherServices");
    this.mapLabelToList(inclusionsLabel, "inclusions");
    this.mapLabelToList(otherServicesLabel, "otherServices");
    
    if (b.hasOwnProperty("Inclusions") && b.hasOwnProperty("OtherServices") && b.hasOwnProperty("Promotions")) {

      let inclusions = JSON.parse(b.Inclusions)
      if (inclusions) {
        this.inclusions = inclusions;
      }

      let os = JSON.parse(b.OtherServices)
      if (os) {
        this.otherServices = os.CheckboxGroup;
        let ios = os.InputOS;

        for (let i = 0; i < this.inputOS.length; i ++) {
          if (this.inputOS[i].Id === ios[i].Id) {
            this.inputOS[i].value = ios[i].value;
          }
        }
      }

      let promotions = JSON.parse(b.Promotions)
      if (promotions) {
        this.promotions = promotions;
      }
    }
    
  },
  resetField: function () {
    this.error = "";
    this.success = false;
    this.inclusions = [];
    this.optionsInc = [];
    this.otherServices = [];
    this.optionsOS = [];
    this.inputOS = [];
    this.inputOSValue = [];
    this.promotions = [{Id:1, value: ""}, {Id:2, value: ""}, {Id:3, value: ""}, {Id:4, value: ""}, {Id:5, value: ""}];
  }
  },
  components: {
  }
}
</script>
